import { render, staticRenderFns } from "./manageCustomers.vue?vue&type=template&id=1a5b509b&"
import script from "./manageCustomers.vue?vue&type=script&lang=js&"
export * from "./manageCustomers.vue?vue&type=script&lang=js&"
import style0 from "./manageCustomers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports